import React from 'react';
import { BsArrowReturnLeft, BsPencilFill } from 'react-icons/bs';

import Message from '../../interfaces/IMessage';

import '../../css/global.css';
import './message.css';
import { formatLocalDateTime } from '../../utils/dateTime';

interface Props {
  message: Message;
}

const MessageChat: React.FC<any> = ({ message }: Props) => {
  const hour = formatLocalDateTime(message.dtEnvioMensagem, 'HH:mm:ss');

  return (
    <div
      className={`d-flex flex-column mw-100 w-100 div-container-msg  ${
        message.seqUsuario === null ? 'align-items-end' : ' align-items-start'
      } `}
    >
      <p
        className="ms-1 mb-0 text-uppercase"
        style={{ color: 'var(--cor-nome-operador-cliente)' }}
      >
        {`${
          message.seqUsuario === null
            ? message.nomeCliente
            : message.nomeUsuario
        }
        ${hour}`}
      </p>
      <div
        className="div-msg"
        style={{
          backgroundColor:
            message.seqUsuario === null
              ? 'var(--cor-caixa-texto-cliente)'
              : 'var(--cor-caixa-texto-operador)',
          color:
            message.seqUsuario === null
              ? 'var(--cor-texto-cliente) !important'
              : 'var(--cor-texto-operador) !important',
          borderRadius:
            message.seqUsuario === null
              ? '0.625rem 0rem 0.625rem 0.625rem'
              : '0rem 0.625rem 0.625rem 0.625rem',
        }}
      >
        {Number(message.seqMensagemOrigem) > 0 && (
          <>
            <BsPencilFill size={16} className="ms-2 me-1 mt-1 mb-1" />
            <span style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
              Editado
            </span>
            <div
              className="text-html ms-2 me-2 mt-0 mb-1 p-1 bg-warning bg-opacity-50 rounded"
              dangerouslySetInnerHTML={{ __html: message.mensagemOrigem }}
            />
            <hr className="m-0 border-top border-2 ms-2 me-2" />
          </>
        )}
        {Number(message.seqMensagemCitacao) > 0 && (
          <>
            <BsArrowReturnLeft size={20} className="ms-1 me-1 mt-1" />
            <span style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
              Citado
            </span>
            <div
              className="text-html ms-2 me-2 mt-0 mb-1 p-1 bg-success bg-opacity-50 rounded"
              dangerouslySetInnerHTML={{ __html: message.mensagemCitacao }}
            />
            <hr className="m-0 border-top border-2 ms-2 me-2" />
          </>
        )}

        <div
          style={{ color: '#fff' }}
          className="text-html ms-2 me-2 fs-lg-1"
          translate="no"
          dangerouslySetInnerHTML={{ __html: message.texto }}
        />
      </div>
    </div>
  );
};

export default MessageChat;
